<template>
  <custom-dialog width="832px" :showClose="true" title="执行划扣" v-if="visibleObj.executeDialog"
    :visible="visibleObj.executeDialog" @close="cancel">
    <div class="execute-warp" slot="content">
      <div class="execute-top">
        <div>执行人：{{ userInfo.nickName }}</div>
        <div>{{ getCurrentDate }}</div>
      </div>
      <div class="table-warp">
        <div class="execute-table" v-for="(item, index) in executeList" :key="item.physioId">
          <div class="table-head">
            <div>
              <el-checkbox v-model="item.checked"></el-checkbox>
              <span class="ml4">{{ item.physioName }}</span>
              <span v-if="item.executionMode==20 && item.onlyNum">(1次{{ item.onlyNum }}组)</span>
            </div>
            <div class="head-right">
              <div> <span class="colorF54A">*</span> 执行次数</div>
              <el-input-number :disabled="!item.checked" class="ml8 number-warp" v-model="item.executeNum" size="mini" :precision="0"
                :min="1" :max="item.executionMode==20 ? computedDivision(item.remainNum,item.onlyNum) : item.remainNum " label="描述文字"></el-input-number>
              <div class="ml8">余{{ item.executionMode==20 ? computedDivision(item.remainNum,item.onlyNum) : item.remainNum }}次</div>
              <div> <span class="colorF54A ml16">*</span> 治疗时长</div>
              <el-input-number class="minute-warp" :disabled="!item.checked" v-model="item.executeTimeLength" :precision="0"
                size="mini" :min="1" :max="999" label="描述文字"></el-input-number>
              <div>分钟</div>
            </div>
          </div>
          <div class="table-row" :class="item.checked ? '' : 'disabled'">
            <div class="row-label"><span class="colorF54A">*</span>诊断</div>
            <div class="row-value color667"> {{ dialogObj.diagnosis }}</div>
            <!-- <el-select :ref="'diagnoseSelect' + index" disabled v-model="dialogObj.diagnosIds"
              class="diagnose-select" allow-create default-first-option filterable remote multiple reserve-keyword
              :remote-method="query => meetDiagnose(query, item)"
              value-key="name" placeholder="">
              <el-option v-for="(item, index) in item.diagnosisOption" class="option-item" :key="index"
                :label="item.name" :value="item">
                <div class="diagnose-warp">
                  <div> {{ item.name }}</div>
                  <div>
                    <span class="diagnose-recode">{{ item.recode }}</span>
                    <span class="diagnose-code">{{ item.code }}</span>
                  </div>
                </div>
              </el-option>
            </el-select> -->
          </div>
          <div class="table-row" :class="item.checked ? '' : 'disabled'">
            <div class="row-label"> <span class="colorF54A">*</span>治疗部位</div>
            <div class="flex1" v-if="item.oldData">
              <el-input type="textarea" autosize class="row-input position-input" :disabled="!item.checked"
                v-model="item.physioPosition" maxlength="500"></el-input>
              <el-popover :ref="'popover' + index" placement="bottom" width="748" trigger="click">
                <div popper-class="parts-warp">
                  <div style="border-bottom: 1px solid #EBEAEE; padding-top:10px;" class="display-f"
                    v-for="partItem in partsList" :key="partItem.label">
                    <div class="color1F23 mr30 flex-sh pt4">{{ partItem.label }}</div>
                    <div class="display-f flex-w ">
                      <div class="part-item" @click="choosePart(item, obj)"
                        :class="computedIsSelect(item.physioPosition, obj) ? 'active' : ''"
                        v-for="obj in partItem.children" :key="obj">{{ obj }}</div>
                    </div>
                  </div>
                  <div @click="closePhysioPosition(index)" class="mt10 color1890 tac pointer"><i
                      class="el-icon-circle-close color1890 mr2"></i>关闭</div>
                </div>
                <el-button type="text" slot="reference" class="btn">选择部位</el-button>
              </el-popover>
            </div>
            <div class="row-value color667" v-else>{{ computedPart(item.acupointinfoList,20) }}</div>
          </div>
          <div class="table-row" :class="item.checked ? '' : 'disabled'">
            <div class="row-label"> <span class="colorF54A">*</span>治疗穴位</div>
            <el-input v-if="item.oldData" type="textarea" autosize class="row-input" :disabled="!item.checked" v-model="item.acupoint"
            maxlength="500"></el-input>
            <div class="row-value color667" v-else>{{ computedPart(item.acupointinfoList,10) }}</div>
          </div>
          <div class="table-row" :class="item.checked ? '' : 'disabled'">
            <div class="row-label"> 治疗反应</div>
            <el-input type="textarea" autosize class="row-input" :disabled="!item.checked" v-model="item.reaction"
              maxlength="500"></el-input>
          </div>
          <div class="table-row" :class="item.checked ? '' : 'disabled'">
            <div class="row-label"> 注意事项</div>
            <el-input type="textarea" autosize class="row-input" :disabled="!item.checked" v-model="item.note"
              maxlength="500"></el-input>
          </div>
        </div>
      </div>
      <div class="btns">
        <custom-button type="info" size="medium" @click="cancel">取消</custom-button>
        <!-- <custom-button type="info" size="medium" @click="executeAndPrint">执行并打印</custom-button> -->
        <custom-button type="primary" size="medium" @click="confirm">执行</custom-button>
      </div>

    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { meetDiagnose } from "@/api/history"; // 病历请求
import { debounce, isNull, isEmptyArray, deepClone, isObject, msgboxWarning,dictText  } from '@/utils/validateBase'
import { partsList } from '@/utils/const'
import { drugDTO, CommonDTO } from '@/DTO/index'
import { Utils } from '@/utils/utils'
export default {
  // 定义引入的组件
  components: { CustomDialog },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      executeList: [],//执行列表
      partsList: partsList,
      userInfo: {},
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
    }
  },
  //变量监听
  watch: {},
  computed: {
    computedIsSelect() {
      return function (physioPosition, obj) {
        let arr = isNull(physioPosition) ? [] : physioPosition.split(',')
        return arr.includes(obj)
      }
    },
    getCurrentDate() {
      return Utils.timeFormat(this.$moment(this.systemTime).startOf('day'), 'yyyy-MM-DD')
    },
    computedPart(){
      let that = this
      const SiFenLeft =[
        { label: '四缝1', value: '1-1' },
        { label: '四缝2', value: '1-2' },
        { label: '四缝3', value: '1-3' },
        { label: '四缝4', value: '1-4' },
      ]
      const SiFenRight =[
        { label: '四缝1', value: '2-1' },
        { label: '四缝2', value: '2-2' },
        { label: '四缝3', value: '2-3' },
        { label: '四缝4', value: '2-4' },
      ]
      return function(acupointinfoList,value){
        let str = ''
        let num = 0
        acupointinfoList && acupointinfoList.forEach(v => {
          if(v.speciesType == value){
            if(v.type == 60){
              let left = ''
              let leftFlag = false
              let right = ''
              let rightFlag = false
              v.typeExtend.forEach(v1=>{
                SiFenLeft.forEach(v2=>{
                  if(v1 == v2.value){
                    leftFlag = true
                    left = left + v2.label + '、'
                  }
                })
                SiFenRight.forEach(v2=>{
                  if(v1 == v2.value){
                    rightFlag = true
                    right = right + v2.label + '、'
                  }
                })
              })
              left =  left.slice(0, -1)
              right = right.slice(0, -1)
              str = str + `【${v.typeExtend.length}】${v.acupointName}(${leftFlag ? '左手：' : ''}${left} ${rightFlag ? '右手：' : ''}${right})、`
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
            }else if(v.type == 50){
              str = str + `【${v.typeExtend[0]}】${v.acupointName}、`
              num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend[0]))
            }else{
              str = str + `【${dictText(v.type, that.acupointType)}】${v.acupointName}、`
              num = v.type == 20 ? num + 2 : num + 1
            }
          }
        })
        if(num > 0){
          str = str.slice(0, -1);
          str = `${str}，共${num}个${value==20 ? '部位':'穴位'}` 
        }
        return str;
      }
    },
    computedDivision(){
      let that = this
      return function(a,b){
        return Number(that.$bigNumber(a, '/', isNull(b)? 1 : b))
      }
    },
  },
  // 页面初始化
  async created() {
    this.systemTime = CommonDTO.getSystemTimeDTO()
    this.userInfo = this.$session.get('user')
    let executeList = deepClone(this.dialogObj.executeList)
    
    if (!isNull(executeList) && !isEmptyArray(executeList)) {
      executeList.forEach(item => {
        // let diagnosisList = []
        // item.diagnosisList && item.diagnosisList.forEach(kid => {
        //   diagnosisList.push({
        //     code: kid.diagnoseCode,
        //     name: kid.diagnoseName
        //   })
        // })
        item.deptId = this.dialogObj.deptId
        item.realExecuteDeptId = this.$session.get('deptId')
        item.reservationIds = (this.dialogObj.reservationInfo && [this.dialogObj.reservationInfo.reservationId]) || []
        item.executeNum = 1
        item.executeTimeLength = ![null, undefined, ''].includes(item.serviceTime) ? item.serviceTime : 60
        item.physioPosition = ''
        item.acupoint = ''
        item.reaction = ''
        item.note = ''
      })
    }
    this.executeList = executeList
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {

    /**
     * 执行
     */
    confirm: debounce(async function () {
      let falg = this.executeList.some(item => { return item.checked })
      if (!falg) return this.$message.error('请选择执行项目')
      let mustFalg = false;
      this.executeList.forEach(item => {
        if (isEmptyArray(item.diagnosIds) || isNull(item.executeNum) || isNull(item.executeTimeLength)) mustFalg = true
      })
      if (mustFalg) return this.$message.error('请填写必填项')
      this.handleExecute().then(res => {
        if (res.code == 200) {
          this.$message.success('执行成功')
          this.$emit('updateData')
        }
      })
    }, true, 1000),
    /**
     * 查询诊断
     */
    meetDiagnose: debounce(function (val, item) {
      if (!isNull(val)) {
        meetDiagnose({ search: val, pageNum: 1, pageSize: 30 }).then(res => {
          if (res.code == 200) {
            item.diagnosisOption = [...item.diagnosIds, ...res.rows]
          }
        })
      }
    }, 300),

    /**
     * 执行理疗（先获取核销码后再执行）
     */
    handleExecute() {
      return new Promise((resolve, reject) => {
        let executeList = deepClone(this.executeList).filter(item=>{ return item.checked  })
        let arr = []
        executeList.forEach(item => {
          arr.push({ ctOrderId:item.ctOrderId, patientId: this.dialogObj.patientId, physioId: item.physioId, executeNum: item.executionMode && item.executionMode == 20 ? item.executeNum * item.onlyNum || 1 : item.executeNum, deptId: item.deptId })
        })
        drugDTO.getUsePhysioCode({ items: arr }).then(res => {
          if (res.code == 200) {
            if (!isEmptyArray(res.data)) {
              executeList.forEach(item => {
                item.patientId = this.dialogObj.patientId
                item.diagnosisList = this.dialogObj.diagnosisList
                item.diagnosis = this.dialogObj.diagnosis
                if(!item.oldData){
                  item.executeNum = item.executionMode && item.executionMode == 20 ? item.executeNum * item.onlyNum || 1 : item.executeNum
                  item.physioPosition = this.computedPart(item.acupointinfoList, 20)
                  item.acupoint = this.computedPart(item.acupointinfoList, 10)
                }
                res.data.forEach(obj => {
                  if (item.physioId == obj.physioId && item.ctOrderId == obj.ctOrderId) { item.useCodes = obj.useCodes }
                })
              })
            }
            drugDTO.usePhysio({
              items: executeList
            }).then(executeRes => {
              resolve(executeRes)
            })
          }
        })
      })
    },

    /**
     * 选择诊断
     */
    diagnosChange(e, item, index) {
      this.$refs[`diagnoseSelect${index}`][0].query = ''
      let arr = []
      e.forEach(item => {
        if (isObject(item)) {
          arr.push({
            diagnoseCode: item.code,
            diagnoseName: item.name,
          })
        } else {
          arr.push({
            diagnoseCode: '',
            diagnoseName: item,
          })
        }
      })
      item.diagnosisList = arr
    },
    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
     * 取消
     */
    cancel() {
      msgboxWarning(this, {
        message: "确定要放弃此次编辑",
        confirmFn: async () => {
          {
            this.$emit('cancelExecute',this.executeList)
          }
        },
        cancelFn: () => {
        },
      });
    },
    /**
     * 选择治疗部位
     */
    choosePart(item, obj) {
      let arr = isNull(item.physioPosition) ? [] : item.physioPosition.split(',')
      if (arr.includes(obj)) {
        let index = arr.findIndex(kid => { return obj == kid })
        arr.splice(index, 1)
      } else {
        arr.push(obj)
      }
      item.physioPosition = arr.join(',')
    },
    /**
     * 执行并打印
     */
    executeAndPrint() {
      this.handleExecute().then(res => {
        if (res.code == 200) {
          this.$message.success('执行成功')
          this.$emit('executeAndPrint', res.data)
        }
      })
    },
    /**
     * 关闭治疗部位
     */
    closePhysioPosition(index) {
      this.$refs[`popover${index}`][0].doClose()
    },
    
  },
}
</script>
<style lang="less" scoped>
.active {
  background: #E8F4FF;
  color: #1890FF !important;
}

.part-item {
  padding: 4px 6px;
  margin-bottom: 6px;
  margin-left: 6px;
  cursor: pointer;
  color: #667182;
  border-radius: 2px;

  &:hover {
    background: #E8F4FF;
    color: #1890FF !important;
  }
}

/deep/.el-input.is-disabled .el-input__inner {
  background: #F0F1F3 !important;
}

.execute-warp {
  font-size: 14px;

  .table-warp {
    max-height: 528px;
    overflow: auto;
  }

  /deep/.el-input.is-disabled .el-input__inner {
    color: #1F2329;
  }

  .disabled {
    background: #F0F1F3 !important;
    cursor: not-allowed;
    pointer-events: none;
  }

  .execute-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1F2329;
    margin-bottom: 8px;
  }

  .execute-table {
    margin-bottom: 16px;
    border: 1px solid #D3D3D5;
    border-radius: 2px;

    .table-head {
      height: 40px;
      background: #F0F1F3;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      border-bottom: 1px solid #D3D3D5;

      .head-right {
        display: flex;
        align-items: center;

        .number-warp {
          width: 88px;

          /deep/.el-input-number__decrease,
          /deep/.el-input-number__increase {
            width: 25px;
          }
        }

        .minute-warp {
          margin-left: 8px;
          width: 64px;
          margin-right: 8px;

          /deep/.el-input-number__decrease,
          /deep/.el-input-number__increase {
            display: none;
          }

          /deep/.el-input {
            width: 64px;
          }

          /deep/.el-input__inner {
            width: 64px;
            padding: 0;
          }
        }
      }
    }

    .table-row {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid #D3D3D5;
      position: relative;

      .btn {
        position: absolute;
        top: 5px;
        right: 12px;
      }

      &:last-child {
        border-bottom: none;
      }

      .row-label {
        width: 96px;
        box-sizing: border-box;
        padding-left: 12px;
        line-height: 40px;
        border-right: 1px solid #D3D3D5;
        flex-shrink: 0;
        color: #667182;
      }

      .row-value {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        line-height: 28px;
        padding-left: 12px;
        box-sizing: border-box;
      }

      .diagnose-select {
        width: 100%;

        /deep/.el-input__inner {
          height: 40px !important;
          border: none;
        }
      }

      .row-input {
        /deep/.el-textarea__inner {
          min-height: 40px !important;
          border: none;
        }
      }

      .position-input {
        /deep/.el-textarea__inner {
          padding-right: 75px;
        }
      }

    }
  }

  .btns {
    margin-top: 10px;
    text-align: right;
  }
}
</style>